import React from 'react';
import { connect } from 'react-redux'
import DistribucionLimitesCuenta from './DistribucionLimitesCuenta.jsx';

//Connect entre el componente y las props y actions.
const DistribucionLimitesCuentaContainer = connect()(DistribucionLimitesCuenta);

export default DistribucionLimitesCuentaContainer;